import React from 'react'
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';


const Create = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [age, setAge] = useState(0);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const navigate=useNavigate();

    const handleSumbit = async (e) => {
        e.preventDefault();
        const addUser = { name, email, age };
        const response = await fetch("https://blogapp1-p9km.onrender.com/", {
            method: 'POST',
            body: JSON.stringify(addUser),
            headers: {
                "Content-type": "application/json"
            }
        });
        const result = await response.json();
        if (!response.ok) {
            setError(result.error)
            setSuccess("");
        }
        if (response.ok) {
            setError("");
            setName("");
            setEmail("");
            setAge(0);
            setSuccess("Successfully stored");
            document.getElementsByClassName('updatedata')[0].style.display="none";
      setTimeout(() => {
        navigate('/all');
      }, 3000);
        }
        // console.log(result)
    }

    return (
        <div className='container'>
            <center>
                <h1>Write Your Blog Here</h1>
                <hr />
            {error && <div className="alert alert-danger text-center" role="alert">{error}</div>}
            {/* {(!error=="")?<div className="alert alert-danger" role="alert">
 {error}</div>:console.log()} */}
            {success && <div className="alert alert-success text-center" role="alert">{success}</div>}
            </center>
            <center className='updatedata'>
                <form onSubmit={handleSumbit}>
                    <div className="mb-3 col-6">
                        <label htmlFor="exampleInputEmail1" className="form-label">Name</label>
                        <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="form-control" aria-describedby="emailHelp" />
                    </div>
                    <div className="mb-3 col-6">
                        <label htmlFor="exampleInputPassword1" className="form-label">Email</label>
                        <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} className="form-control" />
                    </div>
                    <div className="mb-3 col-3">
                        <label htmlFor="exampleInputPassword1" className="form-label">Age</label>
                        <input type="number" value={age} onChange={(e) => setAge(e.target.value)} className="form-control" />
                    </div>
                    <button type="submit" className="btn btn-success">Submit</button>
                </form>
            </center>
        </div>
    )
}

export default Create
